import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Tag } from "primereact/tag";

import styles from "./simulacao-banner.module.scss";
import type { SimulacaoBannerViewModel } from "./types-simulacao-banner";

export function SimulacaoBannerView({
  titulo,
  contador,
  semAlteracoes,
  aviso,
  avisoDivergencias,
  mobile,
  rotuloAplicar,
  rotuloAplicarCompleto,
  rotuloComparar,
  rotuloSair,
  aplicarDesabilitado,
  mostrarAplicar,
  mostrarSair,
  mostrarSairComAlteracoes,
  mostrarComparar,
  sair,
  sairComAlteracoes,
  comparar,
  aplicar,
}: SimulacaoBannerViewModel) {
  const botaoComparar = mostrarComparar ? (
    <Button
      type="button"
      className={`${styles.action} ${styles.comparar}`}
      pt={{ icon: { className: styles.compararIcone } }}
      label={rotuloComparar}
      icon="pi pi-eye"
      severity="secondary"
      onClick={comparar}
      data-testid="simulacao-comparar"
    />
  ) : null;

  return (
    <section
      className={styles.banner}
      aria-label={titulo}
      data-testid="simulacao-banner"
      data-print-hide
    >
      <div className={styles.identity}>
        <span className={styles.accent} aria-hidden />
        <div className={styles.info}>
          <div className={styles.heading}>
            <strong className={styles.title}>{titulo}</strong>
            <Tag
              className={`${styles.counter} ${semAlteracoes ? styles.counterEmpty : styles.counterActive}`}
              value={contador}
              rounded
              data-testid="simulacao-contador"
            />
          </div>
          <span className={styles.notice}>{aviso}</span>
        </div>
        {!mobile && botaoComparar ? (
          <>
            <span className={styles.divider} aria-hidden />
            <div className={styles.consulta}>{botaoComparar}</div>
          </>
        ) : null}
      </div>

      <div className={styles.actions}>
        {mostrarSair ? (
          <Button
            type="button"
            className={`${styles.action} ${styles.sair}`}
            pt={{ label: { className: styles.rotulo } }}
            label={rotuloSair}
            icon="pi pi-times"
            severity="secondary"
            outlined
            onClick={sair}
            data-testid="simulacao-descartar"
          />
        ) : null}
        {mostrarSairComAlteracoes ? (
          <Button
            type="button"
            className={`${styles.action} ${styles.sair}`}
            pt={{ label: { className: styles.rotulo } }}
            label={rotuloSair}
            icon="pi pi-times"
            severity="secondary"
            outlined
            onClick={sairComAlteracoes}
            data-testid="simulacao-arquivar"
          />
        ) : null}
        {mobile ? botaoComparar : null}
        {mostrarAplicar ? (
          <Button
            type="button"
            className={styles.action}
            pt={{ label: { className: styles.rotulo } }}
            label={rotuloAplicar}
            aria-label={rotuloAplicarCompleto}
            icon="pi pi-check"
            disabled={aplicarDesabilitado}
            onClick={aplicar}
            data-testid="simulacao-aplicar"
          />
        ) : null}
      </div>

      {avisoDivergencias ? (
        <Message
          className={styles.divergencias}
          severity="warn"
          text={avisoDivergencias}
          data-testid="simulacao-aviso-divergencias"
        />
      ) : null}
    </section>
  );
}
